<div class="faq" [id]="sectionIds.FAQ">
  <div class="faq__title" data-aos="fade-up">
    <h2 class="faq__title_text gradient-span">{{ 'faq.title' | translate }}</h2>

    <p class="headline-regular">
      {{ 'faq.subTitle' | translate }}
    </p>
  </div>

  <div class="faq__content" data-aos="fade-up">
    <div>
      @for (entity of FAQEntites | slice: 0 : halfOfEntities; track $index) {
        <ui-accordion [title]="entity.key | translate">
          <span accordionContent>{{ entity.value | translate }}</span>
        </ui-accordion>
      }
    </div>

    <div>
      @for (entity of FAQEntites | slice: halfOfEntities : FAQEntites.length; track $index) {
        <ui-accordion [title]="entity.key | translate">
          <span accordionContent>{{ entity.value | translate }}</span>
        </ui-accordion>
      }
    </div>
  </div>
</div>
